import React from 'react';
import { FadeIn } from './FadeIn';
import { PriceTag } from './PriceTag';
import { handleCTAClick } from './MetaPixel';
export function ProductReveal() {
  return <section id="what-you-get" className="py-4 md:py-12 px-4 md:px-6 bg-white border-y border-gold/20" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        {/* Intro */}
        <FadeIn data-id="element-153">
          <div className="text-center mb-4 md:mb-7" data-id="element-154">
            <p className="text-gold font-semibold tracking-widest uppercase text-xs md:text-sm mb-3" data-id="element-155">
              Introducing
            </p>
            <h2 className="font-serif text-[2.4rem] md:text-6xl lg:text-7xl text-navy font-bold leading-[1.1]" data-id="element-156">
              Who Programmed{' '}
              <span className="italic font-normal" data-id="element-157">You to Spend?</span>
            </h2>
            <p className="text-sm md:text-lg text-navy font-extrabold mt-3 max-w-lg mx-auto leading-snug" data-id="element-158">
              The Hidden Psychology Behind Your Money Habits and the System to
              Take Back Control
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-159">
          <div className="max-w-[520px] mx-auto mb-4 md:mb-7" data-id="element-160">
            <p className="text-sm md:text-base text-charcoal/80 font-light text-center mb-3" data-id="element-161">
              This isn't another budgeting guide. It's a deprogramming manual
              for your financial behavior.
            </p>
            <div className="space-y-2.5 mt-4" data-id="element-162">
              <div className="flex items-start gap-3" data-id="element-163">
                <span className="w-5 h-5 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-164">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-165">
                    <polyline points="20 6 9 17 4 12" data-id="element-166" />
                  </svg>
                </span>
                <p className="text-sm md:text-base text-charcoal/85" data-id="element-167">
                  <span className="font-semibold text-navy" data-id="element-168">
                    Uncover hidden triggers
                  </span>{' '}
                  — Learn the psychological patterns behind impulse spending
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-169">
                <span className="w-5 h-5 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-170">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-171">
                    <polyline points="20 6 9 17 4 12" data-id="element-172" />
                  </svg>
                </span>
                <p className="text-sm md:text-base text-charcoal/85" data-id="element-173">
                  <span className="font-semibold text-navy" data-id="element-174">
                    Break the emotional loop
                  </span>{' '}
                  — Practical tools to interrupt the stress → scroll → buy cycle
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-175">
                <span className="w-5 h-5 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-176">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-177">
                    <polyline points="20 6 9 17 4 12" data-id="element-178" />
                  </svg>
                </span>
                <p className="text-sm md:text-base text-charcoal/85" data-id="element-179">
                  <span className="font-semibold text-navy" data-id="element-180">
                    Build a control system
                  </span>{' '}
                  — A simple framework that supports your new habits
                  automatically
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-181">
                <span className="w-5 h-5 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-182">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-183">
                    <polyline points="20 6 9 17 4 12" data-id="element-184" />
                  </svg>
                </span>
                <p className="text-sm md:text-base text-charcoal/85" data-id="element-185">
                  <span className="font-semibold text-navy" data-id="element-186">
                    No spreadsheets or budgets
                  </span>{' '}
                  — Focused on psychology, not numbers
                </p>
              </div>
            </div>
            <p className="text-xs md:text-sm text-charcoal/55 font-light text-center mt-4 italic" data-id="element-187">
              Once you understand the pattern clearly… you can finally break it.
            </p>
          </div>
        </FadeIn>

        {/* Journey Header */}
        <FadeIn data-id="element-188">
          <div className="text-center mb-3 md:mb-5" data-id="element-189">
            <h3 className="font-serif text-xl md:text-2xl text-navy font-bold mb-1.5" data-id="element-190">
              Your Journey Through Four Parts
            </h3>
            <p className="text-sm md:text-base text-charcoal/70 max-w-md mx-auto" data-id="element-191">
              Each stage moves you from awareness → interruption → control.
            </p>
          </div>
        </FadeIn>

        {/* What You Get Inside — Single Block with CTA */}
        <FadeIn data-id="element-192">
          <div className="bg-navy rounded-2xl p-4 md:p-7 max-w-xl mx-auto" data-id="element-193">
            <div className="space-y-4" data-id="element-194">
              <div className="flex items-start gap-3.5" data-id="element-195">
                <div className="w-8 h-8 rounded-lg bg-cream/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-196">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-197">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" data-id="element-198" />
                    <circle cx="12" cy="12" r="3" data-id="element-199" />
                  </svg>
                </div>
                <div data-id="element-200">
                  <p className="font-semibold text-cream text-sm md:text-base" data-id="element-201">
                    The Hidden Spending Program
                  </p>
                  <p className="text-cream/60 text-xs md:text-sm font-light mt-0.5" data-id="element-202">
                    How marketing quietly conditions your brain to spend.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3.5" data-id="element-203">
                <div className="w-8 h-8 rounded-lg bg-cream/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-204">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-205">
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" data-id="element-206" />
                  </svg>
                </div>
                <div data-id="element-207">
                  <p className="font-semibold text-cream text-sm md:text-base" data-id="element-208">
                    The Emotional Spending Cycle
                  </p>
                  <p className="text-cream/60 text-xs md:text-sm font-light mt-0.5" data-id="element-209">
                    Uncover the stress triggers behind your shopping urges.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3.5" data-id="element-210">
                <div className="w-8 h-8 rounded-lg bg-cream/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-211">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-212">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" data-id="element-213" />
                  </svg>
                </div>
                <div data-id="element-214">
                  <p className="font-semibold text-cream text-sm md:text-base" data-id="element-215">
                    Breaking the Program
                  </p>
                  <p className="text-cream/60 text-xs md:text-sm font-light mt-0.5" data-id="element-216">
                    Practical tools to interrupt impulse decisions.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3.5" data-id="element-217">
                <div className="w-8 h-8 rounded-lg bg-cream/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-218">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gold" data-id="element-219">
                    <circle cx="12" cy="12" r="3" data-id="element-220" />
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1Z" data-id="element-221" />
                  </svg>
                </div>
                <div data-id="element-222">
                  <p className="font-semibold text-cream text-sm md:text-base" data-id="element-223">
                    The Financial Control System
                  </p>
                  <p className="text-cream/60 text-xs md:text-sm font-light mt-0.5" data-id="element-224">
                    A simple automated system that supports your new habits.
                  </p>
                </div>
              </div>
            </div>

            <div className="border-t border-cream/15 mt-5 pt-4 text-center" data-id="element-225">
              <p className="text-cream/70 text-xs md:text-sm font-light italic" data-id="element-226">
                Everything structured. Everything practical. Built for women who
                want clarity — not another spreadsheet.
              </p>
            </div>

            {/* CTA inside the block */}
            <div id="money-cta" className="text-center pt-4 pb-1" data-id="element-227">
              <a href="https://www.cleverpockets.com/cart/44891884650632:1" onClick={handleCTAClick} className="inline-block bg-gold text-navy font-semibold text-sm md:text-lg px-7 md:px-10 py-3 md:py-4 rounded-full shadow-lg shadow-gold/25 animate-subtle-glow transition-transform duration-300 hover:scale-105 hover:shadow-xl hover:shadow-gold/30 cursor-pointer" data-id="element-228">
                Start Your Reset
              </a>
              <PriceTag data-id="element-229" />
            </div>
          </div>
        </FadeIn>

        {/* This Guide Is For You If */}
        <FadeIn data-id="element-230">
          <div className="mt-8 md:mt-12 max-w-lg mx-auto bg-cream rounded-2xl p-5 md:p-7 border border-gold/20" data-id="element-231">
            <h3 className="font-serif text-xl md:text-2xl text-navy mb-3 text-center" data-id="element-232">
              This Guide Is For You If…
            </h3>
            <ul className="space-y-2 text-charcoal/80 font-light text-sm md:text-base" data-id="element-233">
              <li className="flex items-start" data-id="element-234">
                <span className="text-gold mr-2.5 mt-0.5" data-id="element-235">✓</span>You
                stress-shop after long days
              </li>
              <li className="flex items-start" data-id="element-236">
                <span className="text-gold mr-2.5 mt-0.5" data-id="element-237">✓</span>You avoid
                checking your bank balance
              </li>
              <li className="flex items-start" data-id="element-238">
                <span className="text-gold mr-2.5 mt-0.5" data-id="element-239">✓</span>You constantly
                say "this month will be different"
              </li>
              <li className="flex items-start" data-id="element-240">
                <span className="text-gold mr-2.5 mt-0.5" data-id="element-241">✓</span>You have a
                closet full of impulse purchases
              </li>
              <li className="flex items-start" data-id="element-242">
                <span className="text-gold mr-2.5 mt-0.5" data-id="element-243">✓</span>You feel
                embarrassed about your spending habits
              </li>
            </ul>
            <p className="mt-4 text-center text-charcoal/70 text-sm italic" data-id="element-244">
              If even two of those sound familiar… this guide was written for
              you.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}